import { lazy } from 'react';

import Loadable from 'components/Loadable';
import AdminGuard from 'utils/route-guard/AdminGuard';
import AdminLayout from 'layout/AdminLayout';

const AdminMerchants = Loadable(lazy(() => import('pages/admin/merchants')));

const AdminRoutes = {
  path: '/admin',
  children: [
    {
      path: 'merchants',
      element: <AdminGuard><AdminLayout /></AdminGuard>,
      children: [
        {
          index: true,
          element: <AdminMerchants />
        }
      ]
    }
  ]
};

export default AdminRoutes;
